export default {
    setActivityLogs(state, logs) {
        state.activityLogs = logs;
    },
    setCurrentActivityLog(state, log) {
        state.currentActivityLog = log;
    },
};
